module.exports = __webpack_public_path__ + "static/Ileri__PO-9449b6ef193de993ec07b8b63b6fd04d.png";